import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RéférentielMétierRessourcesProfessionnellesService {
  refreshData = new Subject();
}
